export const companyCountries = [
  "Belgien",
  "Bulgarien",
  "Dänemark",
  "Deutschland",
  "Estland",
  "Finnland",
  "Frankreich",
  "Griechenland",
  "Irland",
  "Italien",
  "Kroatien",
  "Lettland",
  "Litauen",
  "Luxemburg",
  "Niederlande",
  "Österreich",
  "Polen",
  "Portugal",
  "Rumänien",
  "Schweden",
  "Slowakei",
  "Slowenien",
  "Spanien",
  "Tschechien",
  "Ungarn",
];

export const carBrands = [
  "Abarth",
  "Aiways",
  "Aixam",
  "Alfa Romeo",
  "Alpina",
  "Alpine",
  "Aston Martin",
  "Audi",
  "BMW",
  "BYD",
  "Bellier",
  "Bentley",
  "Borgward",
  "Brilliance",
  "Buick",
  "Cadillac",
  "Casalini",
  "Caterham",
  "Chatenet",
  "Chevrolet",
  "Chrysler",
  "Citroen",
  "Corvette",
  "Cupra",
  "DR",
  "DS Automobiles",
  "Dacia",
  "Daewoo",
  "Daihatsu",
  "Dodge",
  "EVO",
  "Ferrari",
  "Fiat",
  "Fisker",
  "Ford",
  "GWM",
  "Genesis",
  "Great Wall",
  "Haval",
  "Honda",
  "Hummer",
  "Hyundai",
  "ICKX",
  "INEOS",
  "Infiniti",
  "Isuzu",
  "Iveco",
  "Jaguar",
  "Jeep",
  "Kia",
  "LEVC",
  "Lada",
  "Lamborghini",
  "Lancia",
  "Land Rover",
  "Lexus",
  "Ligier",
  "Lotus",
  "Lucid",
  "Lynk & Co",
  "MAN",
  "MAXUS",
  "MG",
  "MG Rover",
  "MINI",
  "Mahindra",
  "Maserati",
  "Maybach",
  "Mazda",
  "Mercedes-Benz",
  "Minauto",
  "Mitsubishi",
  "NIO",
  "Nissan",
  "Opel",
  "Ora",
  "Peugeot",
  "Piaggio (Vespa)",
  "Polestar",
  "Pontiac",
  "Porsche",
  "Proton",
  "Renault",
  "Rolls-Royce",
  "Rover",
  "Saab",
  "Seat",
  "Seres",
  "Skoda",
  "Smart",
  "Sportequipe",
  "SsangYong",
  "StreetScooter",
  "Subaru",
  "Suzuki",
  "Tata",
  "Tesla",
  "Toyota",
  "Triumph",
  "VinFast",
  "Volkswagen",
  "Volvo",
  "Westfield",
  "XPENG",
  "e.GO",
];

export const minBuyPriceValues = [
  0, 250, 500, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000,
  12500, 15000, 17500, 20000, 25000, 30000, 35000, 40000, 50000, 60000, 70000,
  80000, 90000, 100000,
];

export const maxBuyPriceValues = [
  "Unbegrenzt", // remains a string
  100000,
  90000,
  80000,
  70000,
  60000,
  50000,
  40000,
  35000,
  30000,
  25000,
  20000,
  17500,
  15000,
  12500,
  10000,
  9000,
  8000,
  7000,
  6000,
  5000,
  4000,
  3000,
  2000,
  1000,
  500,
  250,
];

export const buyAgeMinValues = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30,
];

export const buyAgeMaxValues = [
  "Älter als 30", // remains a string
  30,
  29,
  28,
  27,
  26,
  25,
  24,
  23,
  22,
  21,
  20,
  19,
  18,
  17,
  16,
  15,
  14,
  13,
  12,
  11,
  10,
  9,
  8,
  7,
  6,
  5,
  4,
  3,
  2,
  1,
];

export const buyKmMinValues = [
  0, 5000, 10000, 25000, 50000, 75000, 100000, 125000, 150000, 200000, 400000,
];

export const buyKmMaxValues = [
  "Unbegrenzt", // remains a string
  400000,
  200000,
  150000,
  125000,
  100000,
  75000,
  50000,
  25000,
  10000,
  5000,
];
